import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { requestsApi, Request } from '../../services/api';
import './RequestContextBar.css';

interface RequestContextBarProps {
  requestId: string;
  onExit?: () => void;
  onHelp?: () => void;
}

function RequestContextBar({ requestId, onExit, onHelp }: RequestContextBarProps) {
  const { t } = useTranslation();
  const [request, setRequest] = useState<Request | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRequest();
  }, [requestId]);

  const loadRequest = async () => {
    try {
      setLoading(true);
      const response = await requestsApi.getById(requestId);
      setRequest(response.data);
    } catch (error) {
      console.error('Failed to load request:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="request-context-bar">
        <div className="context-loading">{t('common.loading')}</div>
      </div>
    );
  }

  if (!request) {
    return null;
  }

  const hubName = request.pickupStartPoint?.name;

  return (
    <div className="request-context-bar">
      <div className="context-content">
        {onExit && (
          <button onClick={onExit} className="btn-context-exit">
            <ArrowLeft size={14} /> {t('common.back')}
          </button>
        )}
        <span className="request-id-badge">{request.requestId}</span>
        <span className="request-title">{request.title}</span>
        {hubName && (
          <>
            <span className="context-separator">|</span>
            <span className="hub-name">{hubName}</span>
          </>
        )}
        {onHelp && (
          <button onClick={onHelp} className="btn-help" title="Help">
            ?
          </button>
        )}
      </div>
    </div>
  );
}

export default RequestContextBar;
